module.exports = __webpack_public_path__ + "fd52f212bacca2e3e15aefd426553192.fbx";